import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";
import { JobseekerDashboard } from "../../config/JobseekerDashboard";
import { EmployeerDashboard } from "../../config/EmployeerDashboard";
import { LocalAgentDashboard } from "../../config/LocalAgentDashboard";



export const jobseekerDashboard = catchAsync(async () => {  
    const data = await httpsCall.get<JobseekerDashboard>(`jobseeker-dashboard/dashboard`);
    return data;
});

export const employeerDashboard = catchAsync(async () => {  
    const data = await httpsCall.get<EmployeerDashboard>(`employer-dashboard/dashboard`);
    return data;
});

export const localAgentDashboard = catchAsync(async () => {  
    const data = await httpsCall.get<LocalAgentDashboard>(`localagents-dashboard/dashboard`);
    return data;
});

